/**
 * Map backend plan features to frontend display format
 */
export const mapPlanFeatures = (plan) => {
  const features = plan.features || {};
  const featureList = [];

  // Portfolio Creation - Always show first
  if (plan.maxPortfolios) {
    const portfolioText = plan.name === 'Basic' 
      ? `${plan.maxPortfolios} Portfolio Creation Student`
      : `${plan.maxPortfolios} Portfolio Creation`;
    featureList.push({
      name: portfolioText,
      accessible: true
    });
  }

  // View other's portfolio
  if (features.view_others_portfolio) {
    featureList.push({
      name: "View other's portfolio",
      accessible: true
    });
  }

  // Access to Govt/Private sector (Popular plan specific)
  if (plan.name === 'Popular' && features.job_profiles) {
    featureList.push({
      name: 'Access to Govt/ Private sector',
      accessible: true
    });
  }

  // Professional Tier / Career Switch (Pro plan)
  if (plan.allowedProfileTypes?.includes('professional')) {
    featureList.push({
      name: 'Professional Tier/ Career Switch',
      accessible: true
    });
  }

  // Cart
  if (features.cart) {
    featureList.push({
      name: 'Cart',
      accessible: true
    });
  }

  // Comment Option (Free plan)
  if (features.comment_option) {
    featureList.push({
      name: 'Comment Option',
      accessible: true
    });
  }

  // Aptitude (Basic plan)
  if (features.aptitude) {
    featureList.push({
      name: 'Aptitude',
      accessible: true
    });
  }

  // Scorecard (Pro plan)
  if (features.scorecard) {
    featureList.push({
      name: 'Scorecard',
      accessible: true
    });
  }

  // Exams (Free plan)
  if (features.exams && plan.name === 'Free') {
    featureList.push({
      name: 'Exams',
      accessible: true
    });
  }

  // Examinations (Basic plan)
  if (features.examinations && plan.name === 'Basic') {
    featureList.push({
      name: 'Examinations',
      accessible: true
    });
  }

  // Examinations & Jobs Profiles (Popular plan)
  if (plan.name === 'Popular' && features.examinations) {
    featureList.push({
      name: 'Examinations & Jobs Profiles',
      accessible: true
    });
  }

  // Job profiles (Pro plan)
  if (features.job_profiles && plan.name === 'Pro') {
    featureList.push({
      name: 'Job profiles',
      accessible: true
    });
  }

  // Notes
  if (features.notes) {
    featureList.push({
      name: 'Notes',
      accessible: true
    });
  }

  // Mentor Credits
  if (plan.mentorCredits > 0) {
    featureList.push({
      name: `Connect with mentor / ${plan.mentorCredits} Credits`,
      accessible: true
    });
  }

  // Courses & Preparation (Basic plan)
  if (features.courses_preparation) {
    featureList.push({
      name: 'Courses & Preparation',
      accessible: true
    });
  }

  // Career Maps
  if (plan.maxCareerMaps) {
    const careerMapsText = plan.maxCareerMaps === -1 
      ? 'Unlimited Career Maps' 
      : `${plan.maxCareerMaps} Career Maps`;
    featureList.push({
      name: careerMapsText,
      accessible: true
    });
  }

  // Explore Opportunities (Pro plan)
  if (features.explore_opportunities) {
    featureList.push({
      name: 'Explore Opportunities',
      accessible: true
    });
  }

  // Hard Skills / Professional Skills (Pro plan)
  if (features.hard_skills_professional) {
    featureList.push({
      name: 'Hard Skills/ professional Skills',
      accessible: true
    });
  }

  // Industry Outlook (Pro plan)
  if (features.industry_outlook) {
    featureList.push({
      name: 'Industry Outlook',
      accessible: true
    });
  }

  // Switch Feature
  if (features.switch_feature) {
    featureList.push({
      name: 'Switch Feature',
      accessible: true
    });
  }

  return featureList;
};

/**
 * Map backend plan to frontend format
 */
export const mapPlanToFrontend = (plan) => {
  return {
    id: plan.id,
    slug: plan.slug,
    name: plan.name,
    price: parseFloat(plan.price),
    billingCycle: plan.billingCycle,
    duration: plan.billingCycle === 'weekly' ? 'week' : plan.billingCycle === 'monthly' ? 'month' : plan.billingCycle === 'yearly' ? 'year' : 'month',
    popular: plan.isPopular,
    features: mapPlanFeatures(plan),
    trialDays: plan.trialDays,
    maxPortfolios: plan.maxPortfolios,
    maxCareerMaps: plan.maxCareerMaps,
    mentorCredits: plan.mentorCredits
  };
};

/**
 * Map all backend plans to frontend format
 */
export const mapPlansToFrontend = (plans) => {
  return plans.map(mapPlanToFrontend);
};
